import React from 'react';
import { Field as FinalField } from 'react-final-form';

type Props = {
  name: string;
  type?: string;
  validate?: any;
  children: any;
  onChange?: any;
};

// this prevents skip empty value on submit
// see problem https://github.com/final-form/react-final-form/issues/430
// solution https://github.com/final-form/react-final-form/issues/130
const identity = (value: any) => (value);

const Field: React.FC<Props> = ({ name, onChange, type = 'input', validate, children }) => {
  return (
    <FinalField
      name={name}
      type={type ?? 'input'}
      subscription={{ value: true, error: true, touched: true }}
      validate={validate}
      parse={identity}
    >
      {({ input, meta }) =>
        children({
          value: input.value,
          onChange: onChange ? onChange(input) : input.onChange,
          valueField: input,
          error: meta.error && meta.touched && meta.error,
        })
      }
    </FinalField>
  );
};

export default React.memo(Field);
